var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "paywall-gifts-groups row paywall-section" },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "plan" }, [
          _c("span", { staticClass: "b-sprite-paywall-pix-gift" }),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("h3", [_vm._v("Gift plan")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Share your love of math and science - give a subscription to Brilliant Premium."
                )
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "btn btn-small",
                  attrs: { to: { name: "gift_purchase_plans" } }
                },
                [_vm._v("\n          Give Premium\n        ")]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "plan group-plan" }, [
          _c("span", { staticClass: "b-sprite-paywall-pix-group" }),
          _vm._v(" "),
          _c("div", [
            _c("h3", [_vm._v("Group plan")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          Want to share Brilliant Premium with your family, class, or team? Learn about our group\n          plans.\n        "
              )
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-small bulk-pricing-trigger ax-click",
                attrs: {
                  href:
                    (_vm.groupPlan && _vm.groupPlan.checkout_url) ||
                    "/premium/group-plans",
                  "data-ax-id": "clicked_groupsales_learn_more"
                }
              },
              [_vm._v("\n          Learn more\n        ")]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "bulk-pricing-text" }, [
      _vm._v(
        "\n          Teacher or professor? Team leader? You can email\n          "
      ),
      _c("a", { attrs: { href: "mailto:pricing@brilliant.org" } }, [
        _vm._v("pricing@brilliant.org")
      ]),
      _vm._v(
        " to find out about bulk\n          pricing for schools and companies.\n        "
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }